/** @file tileFitZoom: the integer zoom that fits a tile in the canvas area (8x to 64x). */

/** Smallest and largest zoom of the Tile canvas (screen pixels per tile pixel). */
const MIN = 8;
const MAX = 64;
/** Room kept around the tile, in screen pixels. */
const MARGIN = 56;

/** `floor(min(areaW / w, areaH / h))` after a margin, clamped to 8..64; 8 for an unmeasured area or an empty tile. */
export function tileFitZoom(size: readonly [number, number], area: readonly [number, number]): number {
  const [w, h] = size;
  if (w <= 0 || h <= 0 || area[0] <= 0 || area[1] <= 0) return MIN;
  const fit = Math.floor(Math.min((area[0] - MARGIN) / w, (area[1] - MARGIN) / h));
  return Math.min(MAX, Math.max(MIN, fit));
}
